import React, { useState, useEffect } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { orderCenterRoutes, standardTubeRoute, useRouter } from '@src/routes'
import CircleLoader from '@src/components/CircleLoader'
import DownloadTemplate from '@src/routes/Configurators/components/DownloadTemplate'
import { Grid, StepContent } from '@material-ui/core'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepConnector from '@material-ui/core/StepConnector'
import Divider from '@material-ui/core/Divider'
import CopyEntry from '@src/routes/Configurators/components/CopyEntry'
import UploadTemplate from '@src/routes/Configurators/components/UploadTemplate'
import Button from '@material-ui/core/Button'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { parseSpreadsheet } from '../ParseSpreadsheet'
import { convertToASCII, getMaxId } from '@src/routes/Configurators/utils/util'
import {
  useCopyPasteTubeMutation,
  useSessionFieldsMutation,
  useUploadTubesFromFileMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import ValidationErrors from '../../../validations/ValidationErrors'
import { configContext } from '../../../utils/StandardReducer'
import { EMPTY_SESSION } from '../EmptySession'
import {
  ActiveLinkType,
  TubeProduct,
  FileFormat,
  UploadType,
  StartRow,
  TubeProperties,
} from '../enum'
import clsx from 'clsx'
import CautionPopUp from '@src/routes/Configurators/components/CautionPopup'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import { useGetProduct } from '@src/routes/Configurators/utils/useGetProduct'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(8, 5),
    },
    step: {
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(6),
    },
    multipleEntryStep: {
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(8.27),
    },
    icon: {
      fill: theme.palette.primary.main,
      borderWidth: 0,
      borderRadius: 24,
      '& $activeIcon': {
        fill: 'theme.palette.primary.main',
      },
    },
    stepperContainer: {
      padding: theme.spacing(2, 0),
      '& .MuiStepLabel-iconContainer': {
        alignSelf: 'flex-start',
      },
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: 22.9,
      fontWeight: theme.typography.fontWeightRegular,
    },
    fieldLabel: {
      marginTop: theme.spacing(5),
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.common.black,
      marginBottom: theme.spacing(5),
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(5),
    },
    stepLabel: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    contentRoot: {
      borderColor: theme.palette.common.white,
      paddingTop: theme.spacing(2),
    },
    uploadButton: {
      backgroundColor: theme.palette.primary.main,
      minWidth: theme.spacing(25),
      width: theme.spacing(50),
      color: theme.palette.common.white,
      '&:disabled': {
        color: theme.palette.common.white,
      },
      marginTop: theme.spacing(2),
    },
    seperator: {
      textAlign: 'center',
      paddingLeft: theme.spacing(7),
    },
    mTop10: {
      marginTop: theme.spacing(-3),
    },
    divider: {
      margin: '10px auto',
      height: '50%',
    },
    resetConnector: {
      display: 'none',
    },
    marginTop20: {
      marginTop: theme.spacing(-5),
    },
    marginTop40: {
      // marginTop: theme.spacing(-10),
    },
    multiEntryTemplate: {
      marginBottom: 0.9,
    },
  }
})

const downloadPCR = {
  url: orderCenterRoutes.index(),
  label: 'PCR Non-Modified Oligos',
  isPCR: true,
  fileName: 'DNA_TUBES_PCR_',
}

const MultipleEntryInfo = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const [text, setText] = useState('')
  const [copyPasteTube, { loading: copypasteLoading }] =
    useCopyPasteTubeMutation()
  const { productDetails, setItemDetails } = props
  const [validationMessage, setValidationMessage] = useState<string[]>([])
  const { state, dispatch } = React.useContext(configContext)
  const [uploadTubesFromFile, { loading: fileUploadLoading }] =
    useUploadTubesFromFileMutation()
  const [upload, setUpload] = useState(false)
  const [disableUpload, setDisableUpload] = useState(true)

  let { sessionData } = state
  const router = useRouter()

  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [uploadDataType, setUploadDataType] = React.useState('')
  const [uploadProductType, setProductType] = React.useState('')
  const [datavalue, setDatavalue] = React.useState<any>('')
  let product = productDetails.productType
  product = useGetProduct(product)

  const reviewPath = `${standardTubeRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.ReviewPage
  }`
  const orderPath = `${standardTubeRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.ConfirmOrder
  }`
  const [sessionFields] = useSessionFieldsMutation()

  useEffect(() => {
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })

    return function cleanupError() {
      dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  const setData = (obj) => {
    sessionData = [EMPTY_SESSION]
    let fiveMod: string
    let threeMod: string
    let cterminalMod: string
    let nterminalMod: string
    obj.forEach((item: any, index: number) => {
      fiveMod = ''
      threeMod = ''
      cterminalMod = ''
      nterminalMod = ''
      if (index > 0) {
        const emptyStateObj = Object.assign({}, EMPTY_SESSION)
        sessionData.push(emptyStateObj)
      }

      if (item.fiveMod) {
        fiveMod = item.fiveMod
      }

      if (item.threeMod) {
        threeMod = item.threeMod
      }
      if (item.cterminalMod) {
        cterminalMod = item.cterminalMod
      }

      if (item.nterminalMod) {
        nterminalMod = item.nterminalMod
      }
      sessionData[index].name = item.name
      sessionData[index].minimumYield = item.minimumYield
      sessionData[index].comments = item.comments
      sessionData[index].id = item.id.toString()
      sessionData[index].oligoId = item.id
      sessionData[index].applyToAll = item.applyToAll
      sessionData[index].baseCount = item.baseCount
      sessionData[index].amount = item.amount
      sessionData[index].concentration = item.concentration
      sessionData[index].countryCode = item.countryCode
      sessionData[index].fiveMod = fiveMod
      sessionData[index].threeMod = threeMod
      sessionData[index].sequence = item.sequence
      sessionData[index].scale = item.scale
      sessionData[index].purification = item.purification
      sessionData[index].format = item.format
      sessionData[index].isOverridden = item.isOverridden
      sessionData[index].tubes = item.tubes.toString()
      sessionData[index].listError = item.listError
      sessionData[index].listWarning = item.listWarning
      sessionData[index].price = item.price
      sessionData[index].currencySymbol = item.currencySymbol
      sessionData[index].currency = item.currency
      sessionData[index].productType = productDetails.productType
      sessionData[index].quantitation = item.quantitation
      sessionData[index].purityLevel = item.purityLevel
      sessionData[index].nterminalMod = nterminalMod
      sessionData[index].cterminalMod = cterminalMod
      sessionData[index].isLabelledAminoAcid = item.isLabelledAminoAcid
      sessionData[index].priceHeaderError = item.priceHeaderError
      sessionData[index].conjugation = item.conjugation
      sessionData[index].conjugationAmount = item.conjugationAmount
      sessionData[index].conjugationChemistry = item.conjugationChemistry
      if (item.flag) {
        sessionData[index].flag = item.flag
      } else {
        sessionData[index].flag = 0
      }
      sessionData[index].additionalCarrierProtein =
        item.additionalCarrierProtein
      if (item.additionalServices) {
        sessionData[index].additionalServices = item.additionalServices
      } else {
        sessionData[index].additionalServices = []
      }
    })

    const newIndex = sessionData.length - 1
    const maxId = getMaxId(sessionData)
    dispatch({
      type: 'ADD_NEW_OLIGO',
      data: maxId,
    })
    dispatch({
      type: 'UPDATE_OLIGO_INDEX',
      data: newIndex,
    })
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: newIndex,
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...sessionData],
    })
    const data = sessionData[newIndex]
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: data.name,
        sequence: data.sequence,
        purityLevel: data.purityLevel,
        amount: data.amount,
        scale: data.scale,
        threeMod: data.threeMod,
        fiveMod: data.fiveMod,
        purification: data.purification,
        format: data.format,
        concentration: data.concentration,
        tubes: data.tubes,
        fullSOligoBackbone: data.fullSOligoBackbone,
        isOverridden: data.isOverridden,
        comments: data.comments,
        cterminalMod: data.cterminalMod,
        nterminalMod: data.nterminalMod,
        otherValue: '',
        isLabelledAminoAcid: data.isLabelledAminoAcid,
        quantitation: data.quantitation,
        conjugation: data.conjugation,
        conjugationAmount: data.conjugationAmount,
        conjugationChemistry: data.conjugationChemistry,
        additionalCarrierProtein: data.additionalCarrierProtein,
        additionalServices: data.additionalServices,
        flag: data.flag,
      },
    })
  }

  const performCopyPaste = (key, value) => {
    setValidationMessage([])
    if (key && key !== '') {
      if (key === messages.CONF_SUCCESS.defaultMessage && value) {
        const obj: any = JSON.parse(value)
        setData(obj)
        setItemDetails(obj)
        let isReviewWarning = false
        obj.forEach((data) => {
          if (data.listWarning && data.listWarning.length !== 0) {
            data.listWarning.forEach((warning) => {
              if (warning.key === TubeProperties.ReviewWarning) {
                isReviewWarning = true
              }
            })
          }
        })
        if (isReviewWarning) {
          dispatch({ type: 'SET_STEP_NO', data: 0 })
          dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
          dispatch({ type: 'IS_BULK_REVIEW', data: true })
          router.push(reviewPath)
        } else {
          dispatch({ type: 'IS_CONFIRM_ORDER', data: true })
          dispatch({
            type: 'ON_CONTINUE_BUTTON_PRICECALL',
            data: true,
          })
          dispatch({ type: 'SET_STEP_NO', data: 1 })
          dispatch({ type: 'IS_COMING_FROM_CONFIRM_PAGE', data: true })
          router.push(orderPath)
          props.navigate()
        }
      } else if (key === messages.CONF_REVIEW_ERROR.defaultMessage && value) {
        // redirect to review page
        const obj: any = JSON.parse(value)
        setData(obj)
        dispatch({ type: 'SET_STEP_NO', data: 0 })
        dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        dispatch({ type: 'IS_BULK_REVIEW', data: true })
        router.push(reviewPath)
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        setValidationMessage([key])
        setText('')
        window.scrollTo(0, 0)
      }
    }
  }

  const copyPaste = async (obj) => {
    const response = await copyPasteTube({
      variables: {
        input: obj,
        productInput: productDetails,
        isOverride: false,
        isDForm: false,
      },
    })
    const { data } = response
    if (data && data.copyPasteTube) {
      if (!data.copyPasteTube.serverError) {
        const { key, value } = data.copyPasteTube
        performCopyPaste(key, value)
      } else {
        window.scrollTo(0, 0)
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
      }
    }
  }

  const handleText = (e) => {
    if (e.target.value.length !== 0) {
      setDisableUpload(false)
    } else {
      setDisableUpload(true)
    }
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    setValidationMessage([])
    setText(e.target.value)
  }

  const ValidateCopyPaste = () => {
    setUpload(false)
    if (
      sessionData.length === 1 &&
      sessionData[0].name === '' &&
      sessionData[0].sequence === ''
    ) {
      copyPaste(convertToASCII(text))
    } else {
      setUploadDataType(UploadType.copyPaste)
      setDatavalue(text)
      setDialogOpen(true)
      setProductType(UploadType.prodType)
    }
  }

  const handleUploadChange = async (file) => {
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    setUpload(true)
    setValidationMessage([])
    if (
      FileFormat.AcceptFormat &&
      FileFormat.AcceptFormat.split(',')
        .map((type) => type.trim().toLowerCase())
        .includes(file?.type)
    ) {
      const inputStr = await parseSpreadsheet(file, productDetails.productType)
      const startRow = parseInt(StartRow[productDetails.productType])
      if (inputStr === FileFormat.InvalidTemplate) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        setValidationMessage([
          intl.formatMessage(messages.CONF_INVALID_TEMPLATE),
        ])
      }
      if (inputStr === FileFormat.MultipleLineError) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        setValidationMessage([intl.formatMessage(messages.MULTIPLE_LINE_ERROR)])
      }
      if (inputStr === '') {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        setValidationMessage([intl.formatMessage(messages.CONF_EMPTY_FILE)])
      }
      if (
        inputStr !== '' &&
        inputStr !== FileFormat.MultipleLineError &&
        inputStr !== FileFormat.InvalidTemplate
      ) {
        //make api call here passing inputStr as input
        const response = await uploadTubesFromFile({
          fetchPolicy: 'no-cache',
          variables: {
            input: inputStr,
            productInput: productDetails,
            isOverride: false,
            isDForm: false,
            startRow: startRow,
          },
        })
        const { data } = response

        if (data && data.uploadTubesFromFile) {
          if (!data.uploadTubesFromFile.serverError) {
            const { key, value } = data.uploadTubesFromFile
            performCopyPaste(key, value)
          } else {
            window.scrollTo(0, 0)
            dispatch({
              type: 'SET_PAGE_ERROR',
              data: ConfiguratorValues.InternalServerError,
            })
          }
        }
      }
    } else {
      if (file !== undefined) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        setValidationMessage([intl.formatMessage(messages.CONF_INVALID_FORMAT)])
      }
    }
  }

  const validateText = () => {
    if (text !== null) {
      ValidateCopyPaste()
    }
  }
  const validateUploadFile = (file) => {
    setText('')
    setDisableUpload(true)
    if (
      sessionData.length === 1 &&
      sessionData[0].name === '' &&
      sessionData[0].sequence === ''
    ) {
      handleUploadChange(file)
    } else {
      setUploadDataType(UploadType.fileUpload)
      setDatavalue(file)
      setDialogOpen(true)
      setProductType(UploadType.prodType)
    }
  }

  const sessionDataToSession = async (obj) => {
    await sessionFields({
      variables: { input: obj, productInput: productDetails },
    })
  }
  const clearSessionData = () => {
    dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    dispatch({ type: 'SET_STEP_NO', data: 0 })
    sessionDataToSession([])
    dispatch({
      type: 'UPDATE_OLIGO_INDEX',
      data: 0,
    })
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: 0,
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [
        {
          additionalCarrierProtein: 'None',
          additionalComments: '',
          additionalServices: [],
          amount: '',
          applyToAll: false,
          autoValidation: '',
          baseCount: 0,
          carrierProtein: '',
          cartId: '',
          comments: '',
          concentration: '',
          conjugation: 'None',
          conjugationAmount: '',
          conjugationChemistry: '',
          countryCode: '',
          crossContamination: '',
          crRnaType: '',
          cterminalMod: '',
          currency: '',
          currencySymbol: '',
          customPeptideType: '',
          epsilon: 0,
          fiveMod: '',
          fiveModCategory: '',
          flage: 0,
          format: 'DRY',
          fullSOligoBackbone: false,
          gcContent: '',
          id: '1',
          internalModCategory: '',
          isLabelledAminoAcid: true,
          isoCode: false,
          isOverridden: false,
          itemId: '',
          listError: [],
          material: '',
          meltingTemparature: '',
          minimumYield: '',
          molecularWeight: '',
          name: '',
          nterminalMod: '',
          oligoId: 1,
          orderItemId: '',
          otherValue: '',
          packageType: '',
          plateType: '',
          price: '',
          primerDimer: '',
          productType: '',
          purification: '',
          purityLevel: '',
          quantitation: '',
          scale: '',
          secondaryStructure: '',
          sequence: '',
          sequenceLocation: '',
          threeMod: '',
          threeModCategory: '',
          tubes: '1',
        },
      ],
    })

    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: '',
        concentration: '',
        tubes: '1',
        countryCode: '',
        fullSOligoBackbone: false,
        isOverridden: false,
        comments: '',
        cterminalMod: '',
        nterminalMod: '',
        otherValue: '',
        isLabelledAminoAcid: true,
        quantitation: '',
        purityLevel: '',
        amount: '',
        additionalServices: [],
        flag: 0,
      },
    })
  }

  const saveToSession = (type, data) => {
    clearSessionData()
    if (type === UploadType.copyPaste) {
      copyPaste(convertToASCII(data))
    } else if (type === UploadType.fileUpload) {
      handleUploadChange(data)
    }
  }

  return (
    <div className={classes.contentWrapper}>
      <div>
        <FormattedMessage
          {...messages.CONF_OPTIONAL_INTR_MOD_TEMPLATE_standard}
        />
      </div>

      <Stepper
        orientation="vertical"
        classes={{ root: classes.stepperContainer }}
        connector={
          <StepConnector
            classes={{
              root: classes.resetConnector,
            }}
          />
        }
        nonLinear
      >
        <Step active className={classes.multipleEntryStep}>
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.icon,
              },
            }}
          >
            <Grid container alignItems="center" spacing={3}>
              <Grid item xs={12}>
                <div className={classes.label}>
                  <FormattedMessage {...messages.CONF_MULTIPLE_ENTRY_STEP_1} />
                </div>
              </Grid>
              <Grid item sm={5} className={classes.marginTop20}>
                <Grid container spacing={1}>
                  <Grid item>
                    <DownloadTemplate
                      items={{
                        isPCR: false,
                        label: 'Multiple entry template',
                      }}
                      productDetails={productDetails}
                    />
                  </Grid>
                </Grid>
                {productDetails.productType === TubeProduct.Standard ? (
                  <DownloadTemplate
                    items={downloadPCR}
                    productDetails={productDetails}
                  />
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </StepLabel>
        </Step>
        <Step
          active
          className={clsx(
            classes.step,
            productDetails.productType !== TubeProduct.Standard
              ? classes.mTop10
              : ''
          )}
        >
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.icon,
              },
            }}
          >
            <div className={classes.stepLabel}>
              <FormattedMessage {...messages.CONF_MULTIPLE_ENTRY_STEP_2} />
            </div>
          </StepLabel>
        </Step>
        <Step active className={classes.step}>
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.icon,
              },
            }}
          >
            <div className={classes.stepLabel}>
              <FormattedMessage {...messages.CONF_MULTIPLE_ENTRY_STEP_3} />
            </div>
          </StepLabel>
          <StepContent
            classes={{
              root: classes.contentRoot,
            }}
          >
            <Grid container>
              <Grid item sm={3}>
                <UploadTemplate
                  accept={FileFormat.AcceptFormat}
                  handleUploadChange={([file]) => validateUploadFile(file)}
                />
                {upload && (
                  <div>
                    <ValidationErrors errors={validationMessage} />
                  </div>
                )}
              </Grid>
              <Grid item className={classes.seperator}>
                <span className={classes.fieldLabel}>
                  <FormattedMessage {...messages.CONF_OR} />
                </span>
                <Divider orientation="vertical" className={classes.divider} />
              </Grid>
              <Grid item sm={7}>
                <CopyEntry
                  handlechange={handleText}
                  text={text}
                  productDetails={props.productDetails}
                />
                {!upload && (
                  <div>
                    <ValidationErrors errors={validationMessage} />
                  </div>
                )}
              </Grid>
            </Grid>
          </StepContent>
        </Step>
        <Step active className={classes.step}>
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.icon,
              },
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={clsx(
                classes.uploadButton,
                fileUploadLoading || disableUpload
              )}
              type="submit"
              onClick={validateText}
              disabled={fileUploadLoading || disableUpload}
              id="tubes-upload-button"
              data-testid="tubes-upload-button"
            >
              <FormattedMessage {...messages.CONF_UPLOAD_YOUR_DATA} />
            </Button>
          </StepLabel>
        </Step>
      </Stepper>
      <CautionPopUp
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        saveToSession={saveToSession}
        uploadDataType={uploadDataType}
        data={datavalue}
        prodType={uploadProductType}
      />
      {(copypasteLoading || fileUploadLoading) && <CircleLoader />}
    </div>
  )
}

export default MultipleEntryInfo
